import React from "react";
import makeStyles from "@mui/styles/makeStyles";

import DoneIcon from "@mui/icons-material/Done";
import ListItemIcon from "@mui/material/ListItemIcon";
import MenuItem from "@mui/material/MenuItem";
import { Typography } from "@mui/material";

const useStyles = makeStyles(theme => ({
  root: {
    justifyContent: "space-between",
  },

  checkmark: {
    justifyContent: "end",
    color: theme.palette.primary.main,
  },

  selected: {
    backgroundColor: "transparent !important",
    "& p": {
      color: theme.palette.primary.main,
      fontWeight: 700,
    },
    "&:hover": {
      backgroundColor: `${theme.palette.primary.main} !important`,
      color: "white",
      "& p, & svg": {
        color: "white",
      },
    },
  },
}));

const SelectableMenuItem = React.forwardRef(({ label, MenuItemProps }, ref) => {
  const classes = useStyles();
  return (
    <MenuItem
      ref={ref}
      classes={{ root: classes.root, selected: classes.selected }}
      onClick={MenuItemProps.onClick}
      selected={MenuItemProps.selected}
    >
      <Typography className={classes.text} noWrap>
        {label}
      </Typography>
      {MenuItemProps.selected && (
        <ListItemIcon classes={{ root: classes.checkmark }}>
          <DoneIcon />
        </ListItemIcon>
      )}
    </MenuItem>
  );
});

export default SelectableMenuItem;
